import React from 'react'

function LoadingBox() {
    return (
        <div className="loading">
            <i className="fa fa-spinner fa-spin"></i> Loading... 
        </div>
    )
}

export default LoadingBox
